export const AUTH_LOGOUT = "/v2/auth/logout";

export const FAXES = "/v2/fax/get_faxes";
export const DELETE_FAXES = "/v2/fax/delete";
export const DOWNLOAD_FAXES = "/v2/fax/download";
export const UPDATE_FAXES = "/v2/fax/update";
export const SEND_FAX = "/v2/fax/send_fax";
export const RESEND_FAX = "/v2/fax/resend_fax";

export const GET_INFO = "/v2/fax/get_ui";
export const USER_MIGRATION = "/v2/fax/migrate_account";
export const GET_NUMBER = "/v2/fax/get_number";

export const CONTACTS = "/v2/fax/contacts";
export const FAX_STATUS = "/v2/fax/get_status";

// Cover page
export const COVER_PAGE = "/v2/cover-pages";

export const NUMBER_LIST = "/v2/numbers";

export const USER_LIST = "/v2/users";

export const DELETE_COVER_PAGE = (id:number)=> `/v2/cover-pages/${id}`;

export const ASSIGN_USER = (coverpage_id: number,user_id:number)=> `/v2/cover-pages/assigned_users/${coverpage_id}/${user_id}`;

export const ASSIGN_NUMBER = (coverpage_id: number,number_id:number)=> `/v2/cover-pages/assigned_numbers/${coverpage_id}/${number_id}`;

export const CHECK_COVER_PAGE = (user_id: number, number_id: number) =>
  `/v2/cover-pages/check/${user_id}/${number_id}`;


